let platform = [
    {
        path: 'platform',
        name: '平台运营',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'content',
                component: () => import("@/views/admin/operate/platform/content/index.vue"),
                name: '内容运营',
                meta: {
                    hidden: true,
                    key:21001
                },
            },
            {
                path: 'user',
                // component: () => import("@/views/admin/operate/platform/user/index.vue"),
                component: () => import("@/views/admin/member/gocardless/marketing/index.vue"),
                name: '用户运营',
                meta: {
                    hidden: true,
                    key:21002
                },
            },

        ]
    }
]

let channel = [
    {
        path: 'channel',
        name: '渠道运营',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'flow',
                component: () => import("@/views/admin/operate/channel/flow/index.vue"),
                name: '渠道流程管理',
                meta: {
                    hidden: true,
                    key:22001
                },
            },
            {
                path: 'member',
                component: () => import("@/views/admin/operate/channel/member/index.vue"),
                name: '渠道成员管理',
                meta: {
                    hidden: true,
                    key:22002
                },
            }
        ]
    }
]

let DevOps = [
    {
        path: 'DevOps',
        name: '技术运维管理',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'train',
                component: () => import("@/views/admin/operate/DevOps/train/index.vue"),
                name: '技术培训管理',
                meta: {
                    hidden: true,
                    key:23001,
                    type:17
                },
            },
            {
                path: 'supervise',
                component: () => import("@/views/admin/operate/DevOps/train/index.vue"),
                name: '技术运维管理',
                meta: {
                    hidden: true,
                    key:23002,
                    type:18
                },
            },
            {
                path: 'archives',
                component: () => import("@/views/admin/operate/DevOps/train/index.vue"),
                name: '技术档案管理',
                meta: {
                    hidden: true,
                    key:23003,
                    type:19
                },
            },
            {
                path: 'alter',
                component: () => import("@/views/admin/operate/DevOps/train/index.vue"),
                name: '平台变更管理',
                meta: {
                    hidden: true,
                    key:23004,
                    type:20
                },
            },
        ]
    }
]







export const operate = [
    {
        path: '/operate',
        name: '运营管理系统',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...platform,//平台运营
            ...channel,//渠道运营
            ...DevOps,//技术运维管理
        ]
    },

]
